import { SUMMARY_TABLE, SUMMARY_TRENDS } from '../../../../../shared/constants/analytics/contexts';
import { ALL_DATA_VALUE } from '../../../../../shared/constants/summary';
import { SummaryProductContextService } from '../../../../../shared/SummaryProductContext.service';
import type { ProductType } from '../../../../../shared/types/summary.types';
import { PRODUCT_REPORT_ENDPOINT_MAPPING, PRODUCT_TRENDS_ENDPOINT_MAPPING } from './newSummaryConstants';

const DEFAULT_FALLBACK_PRODUCT = ALL_DATA_VALUE;

export class SummaryEndpointsService {
  getSummaryEndpointByContext(context: string, fallbackProduct: ProductType = DEFAULT_FALLBACK_PRODUCT): string | undefined {
    if (!SummaryProductContextService.isSummaryProductContext(context)) {
      return undefined;
    }

    const [summaryBaseContext, product] = SummaryProductContextService.decodeContext(context);

    if (summaryBaseContext === SUMMARY_TRENDS) {
      return PRODUCT_TRENDS_ENDPOINT_MAPPING[product || fallbackProduct];
    }

    if (summaryBaseContext === SUMMARY_TABLE) {
      return PRODUCT_REPORT_ENDPOINT_MAPPING[product || fallbackProduct];
    }
  }
}
